<template>
  <div class="p10">
    <div class="bg p20 flex flex-between item-center mb10">
      <div>
        <el-button-group>
          <el-button
            size="mini"
            type="primary"
            :plain="typeRange != 1"
            @click="setTypeRange(1)"
            >未打标签</el-button
          >
          <el-button
            size="mini"
            type="primary"
            :plain="typeRange != 2"
            @click="setTypeRange(2)"
            >已打标签</el-button
          >
        </el-button-group>
      </div>
      <div v-if="typeRange == 1">
        <div
          v-for="(v, i) in sort"
          :key="i"
          @click="sortList(v)"
          class="mr10 pointer"
          :class="{ primary: selectSort.prop === v.prop }"
        >
          {{ v.title }}
          <i class="el-icon-sort" v-if="selectSort.prop !== v.prop"></i>
          <i
            class="el-icon-sort-down"
            v-else-if="
              selectSort.prop === v.prop && selectSort.order === 'ascending'
            "
          ></i>
          <i
            class="el-icon-sort-up"
            v-else-if="
              selectSort.prop === v.prop && selectSort.order === 'descending'
            "
          ></i>
        </div>
      </div>
      <div v-if="typeRange == 2">
        <!-- <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          disabled
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10"
        ></el-date-picker> -->
        <el-input
          clearable
          v-model.trim="searchCondition.storeName"
          placeholder="请输入商户名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.shopName"
          placeholder="请输入门店名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.tagName"
          placeholder="请输入标签名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          placeholder="请选择标签类型"
          v-model="searchCondition.fieldType"
          class="mr10"
          filterable
          
        >
          <el-option
            v-for="item in allMerchant"
            :key="item.itemValue"
            :label="item.itemText"
            :value="item.itemValue"
          ></el-option>
        </el-select>
        <!-- <el-input
          clearable
          v-model.trim="searchCondition.declareSn"
          placeholder="请输入申报单号"
          size="small"
          class="ipt mr10"
        ></el-input> -->
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <hm-content title :hidden="hidden">
    <div class="table bg p20" v-if="typeRange == 2">
      <el-table
        ref="table"
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="declareSn"
          label="申报单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="商户编码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fieldTypeName"
          label="问题类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="标签名称"
          label="标签名称"
          width="300"
        >
          <template slot-scope="scope">
            <el-tag>{{ scope.row.tagName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="打标时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="操作人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="240"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                slot="reference"
                @click="removeTag(scope.row, scope.$index)"
                >移除标签</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <div class="p10" v-else>
      <el-row :gutter="20">
        <el-col
          style="width: 20%"
          class="grid-content"
          v-for="(item, index) in provinceList"
          :key="index"
        >
          <div class="box_content mb20 pointer" @click="gotoUrl(item)">
            <div class="box_title_box mb10">
              <div class="box_title">{{ item.provinceName }}</div>
              <i class="el-icon-star-off"></i>
            </div>
            <div class="box_content_box">
              <div class="imgBox">
                <i class="el-icon-s-shop imgIcon"></i>
                <!-- <img
                  src="https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E5%AE%A1%E6%A0%B8%402x.png"
                  alt=""
                /> -->
              </div>
              <div class="box_content_box_text">
                <div class="box_content_box_text_title">门店总数</div>
                <div>{{ item.shopCount }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    </hm-content>
  </div>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      hidden: true,
      typeRange: "2",
      sort: [
        {
          title: "按数量排序",
          order: "",
          prop: "minDeclareNumber",
        },
      ],
      selectSort: {
        title: "",
        order: "",
        prop: ":",
      },
      searchCondition: {
        fieldType:''
      },
      isOutputing: false,
      allMerchant: [],
      storeBasicList: [],
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      provinceList: [],
    };
  },
  watch: {},
  created() {
    this.queryGetEnumData();
  },
  mounted() {},
  methods: {
    setTypeRange(e) {
      this.typeRange = e;
      if (e == 2) {
        this.queryList();
      } else {
        this.queryStoreTagCount();
      }
    },
    sortList(selectSort) {
      switch (selectSort.order) {
        case "ascending":
          selectSort.order = "descending";
          break;
        case "descending":
          selectSort.order = "ascending";
          break;
        default:
          selectSort.order = "ascending";
      }
      this.selectSort = selectSort;
      this.queryStoreTagCount();
    },
    //   remoteMethod(query) {
    //   if (query !== "") {
    //     this.storeBasicList = this.allMerchant.filter(
    //       (v) => v.storeName.indexOf(query) > -1
    //     );
    //   } else {
    //     this.storeBasicList = [];
    //   }
    // },
    async queryGetEnumData() {
      // const { result } = await this.$store.dispatch("getEnumData", {
      //   enumType: "declareQuestionType",
      // });
      const { result } = await this.$store.dispatch("declareTemplateType");
      this.allMerchant = result;
      this.searchCondition.fieldType = "number";
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.startTime = this.isArray(searchCondition.applyDate)
      //   ? searchCondition.applyDate[0]
      //   : "";
      // searchCondition.endTime = this.isArray(searchCondition.applyDate)
      //   ? searchCondition.applyDate[1]
      //   : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryTagPageList", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async queryStoreTagCount() {
      let params = {
        numOrder: this.selectSort.order == "ascending" ? false : true,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreTagCount",
        params
      );
      this.provinceList = result;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    removeTag(row, index) {
      this.$confirm("确定是移除该标签？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确认删除",
        type: "warning",
      }).then(() => {
        this.deleteTagMatchLog(row, index);
        // this.tagList.splice(index, 1);
        // if (row.id) {
        //   this.tagRemove(row.id);
        // }
      });
    },
    async deleteTagMatchLog(row, index) {
      let params = {
        id: row.declareJoinTagId,
        delFlag: "1",
        storeCode: row.storeCode,
      };
      await this.$store.dispatch("declareJoinTagEdit", params).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "移除成功",
            type: "success",
          });
          this.list.splice(index, 1);
          if (this.list.length == 0) {
            this.currentPage = 1;
            this.queryList();
          }
        }
      });
    },
    gotoUrl(info) {
      this.$router.push({
        path: "/guiderCommission/receiptTemplate/labelConfiguration",
        query: {
          storeProvince: info.storeProvince,
          provinceName: info.provinceName,
        },
      });
    },
    async output() {
      this.isOutputing = true;
      try {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );

        // 启用时间范围处理逻辑
        // if (
        //   this.searchCondition.applyDate &&
        //   this.searchCondition.applyDate.length > 0
        // ) {
        //   searchCondition.startTime = this.searchCondition.applyDate[0];
        //   searchCondition.endTime = this.searchCondition.applyDate[1];
        // }

        // 添加分页参数，确保导出所有数据
        // searchCondition.pageNo = 1;
        // searchCondition.pageSize = this.total; // 导出全部数据

        // 调用导出接口并获取 blob 数据
        const response = await this.$store.dispatch(
          "exportTagList",
          searchCondition
        );
        setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
      }, 0);
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败，请重试");
      } finally {
        this.isOutputing = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bg {
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px 16px 16px 16px;
}
.grid-content {
  display: flex;
  flex-wrap: wrap;
  .box_content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    border-radius: 16px 16px 0px 0px;
    .box_title_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .box_title {
        font-weight: 600;
        font-size: 20px;
        color: #111827;
      }
    }
    .box_content_box {
      display: flex;
      .imgBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: #faf5ff;
        border-radius: 50%;
        .imgIcon {
          color: #a855f7;
          font-size: 24px;
        }
        img {
          width: 30px;
          height: 30px;
        }
      }
      .box_content_box_text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 20px;
        font-weight: 700;
        font-size: 24px;
        color: #111827;
        .box_content_box_text_title {
          font-weight: 400;
          font-size: 14px;
          color: #6b7280;
        }
      }
    }
  }
  .box_content::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(270deg, #3b82f6 0%, #a855f7 100%);
  }
}
</style>
